import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

function Loader({ icon, size, className }) {
  return (
    <div className={"is-flex is-justify-content-center "}>
      <FontAwesomeIcon size={size} className={`fa fa-spin`} icon={icon ? icon : faSpinner} />
    </div>
  );
}

export default Loader;
